import { Texto } from '@gravitate-js/excalibrr'
import { Card, Form, List, Switch, type FormInstance } from 'antd'
import type { FormValues } from './types'
import { SETTINGS_DATA } from './constants'
import type { FreightLinkingOptionsResponse } from '@/api/useFreightAssessorials/types'
import { FreightLinkingOptionsSelect } from '../../../components/FreightLinkingOptionsSelect'

type AdditionalSettingsCardProps = {
  form?: FormInstance<FormValues>
  specialPayOptions: FreightLinkingOptionsResponse['data']
}

export function AdditionalSettingsCard({ form, specialPayOptions }: AdditionalSettingsCardProps) {
  return (
    <Card size='small' style={{ marginBottom: 16 }}>
      <List
        itemLayout='horizontal'
        dataSource={SETTINGS_DATA}
        renderItem={(item) => (
          <List.Item
            actions={[
              <Form.Item key={`setting-${item.fieldName}`} name={item.fieldName} valuePropName='checked' noStyle>
                <Switch />
              </Form.Item>,
            ]}
          >
            <List.Item.Meta title={item.title} description={<Texto appearance='hint'>{item.description}</Texto>} />
          </List.Item>
        )}
      />
      <FreightLinkingOptionsSelect form={form} specialPayOptions={specialPayOptions} />
    </Card>
  )
}
